const HomeIcon = (props) => {
    return (
        <svg
          width={25}
          height={25}
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#clip0_236_56)" fill="#fff">
            <path d="M24.135 10.688L13.198.791a1.042 1.042 0 00-1.396 0L.865 10.688A1.048 1.048 0 002.26 12.25L12.5 2.969l10.24 9.26a1.048 1.048 0 001.395-1.562v.02zM21.875 13.542a1.042 1.042 0 00-1.042 1.041v7.813H4.167v-7.813a1.042 1.042 0 00-2.084 0v8.854a1.042 1.042 0 001.042 1.042h18.75a1.041 1.041 0 001.042-1.041v-8.855a1.042 1.042 0 00-1.042-1.041z" />
          </g>
          <defs>
            <clipPath id="clip0_236_56">
              <path fill="#fff" d="M0 0H25V25H0z" />
            </clipPath>
          </defs>
        </svg>
      )
}

export default HomeIcon